import { apiRequest } from "@/lib/api-client";

import type { Moment } from "./types";

export function listMoments() {
  return apiRequest<Moment[]>("/moments");
}

export function updateMomentPublishMetadata(
  momentId: string,
  publishDescription: string | null,
  publishHashtags: string | null
) {
  return apiRequest<Moment>(`/moments/${momentId}/publish-metadata`, {
    method: "PATCH",
    body: JSON.stringify({
      publish_description: publishDescription,
      publish_hashtags: publishHashtags
    })
  });
}
